import ServerMiddleware from "@framework/relay/server/network/server-middleware";

const basicAuthMiddleware: ServerMiddleware = (next) => (ctx) => {
  const wpPlatformApiToken = process.env.WP_PLATFORM_API_TOKEN;

  if (!wpPlatformApiToken) {
    throw new Error(
      "WP_PLATFORM_API_TOKEN environment variable is required for basic auth middleware.",
    );
  }

  ctx.fetchOpts.headers.Authorization = `Basic ${Buffer.from(
    `duet:${wpPlatformApiToken}`,
  ).toString("base64")}`;

  return next(ctx);
};

export default basicAuthMiddleware;
